import {CerbaCookieService, CookieConstantes, TagConstantes, CorrespondantStore} from "@digicerba/common";
import {CorrespondantDetailsDto, ICorrespondantWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router} from "@angular/router";
import * as lodash from "lodash";

@Injectable()
export class CorrespondantDetailsResolver implements Resolve<CorrespondantDetailsDto> {

  constructor(private correspondantWebServiceClient: ICorrespondantWebServiceClient,
              private cookieService: CerbaCookieService,
              private router: Router,
              private correspondantStore: CorrespondantStore) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    if (route.queryParams['correspondant']) {
      let queryValue = route.queryParams['correspondant'];
      this.correspondantWebServiceClient.getAllTags().subscribe((tags) => {
        if (lodash.findIndex(tags, function (t) {
            return t == TagConstantes.VALIDEUR;
          }) == -1) {
          this.correspondantWebServiceClient.getCorrespondants().subscribe((correspondants) => {
            if (lodash.findIndex(correspondants, function (c) {
                return c.code == queryValue;
              }) != -1) {
              this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
              this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, queryValue);
            }
          })
        } else {
          if (this.cookieService.getCoockieValue(CookieConstantes.COOKIE_CORRESPONDANT) != queryValue) {
            this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
            this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, queryValue);
          }
        }
      })
      this.router.navigate(['cerba/panier']);
    }
    var cookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_CORRESPONDANT);

    if (cookieValue) {
      return this.correspondantWebServiceClient.getCorrespondantDetails(cookieValue);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/gestion-panier/correspondant.details.resolver.ts